import * as types from '../actions/constants'

const INITIAL_STATE = {
    list: [],
    current_category: "",
    subcategories: [],
    groups: [],
};
export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case types.FETCH_CATEGORIES:
            return {...state, list: action.payload}
        case types.SET_CATEGORY:
            return {...state, current_category: action.payload}
        case types.FETCH_SUBCATEGORIES:
            return {...state, subcategories: action.payload}
        case types.FETCH_GROUPS:
            return {...state, groups: action.payload}
        default:
            return state;


    }
}